import axiosInstance from './axiosInstance'; // ✅ default import

export type Notice = {
  id: number;
  title: string;
  content: string;
  images: string[];
  createdAt: string;
  updatedAt: string;
  openedAt: string;
  sortIndex: number;
};
// 공지사항 전체 조회
export const fetchNotices = async (): Promise<Notice[]> => {
  const res = await axiosInstance.get<Notice[]>('/api/allbadeum/v1/notice');
  return res.data;
};

// ✅ 공지사항 단건 조회
export const fetchNoticeById = async (id: number): Promise<Notice> => {
  const res = await axiosInstance.get<Notice>(`/api/allbadeum/v1/notice/${id}`);
  return res.data;
};
